import { useSetting, useVersionCookie } from '@ui/hooks'
import getConfig from 'next/config'

export const useCdnBasePathImage = () => {
  const versionCookie = useVersionCookie()
  const [storeSetting] = useSetting('store')
  const cookie = storeSetting?.version || versionCookie
  const config = getConfig().publicRuntimeConfig // Move getConfig call inside the hook

  return cookie === 'vna1' ? `${config.cdnBasePathNonArgo}` : `${config.cdnBasePath}`
}

const cdnBasePath = getConfig().publicRuntimeConfig.cdnBasePath
const cdnImages = getConfig().publicRuntimeConfig.cdnImages
const previewImagePath = getConfig().publicRuntimeConfig.previewImagePath

export const iconPath = (url: string, basepath = cdnBasePath) => `${basepath}/${cdnImages}/${url}`
export const imagePath = (url: string, basepath = cdnBasePath) => `${basepath}/${url}`

export const previewImage = (path = '') => `${previewImagePath}${path}`
